<template>
    <div>
      <!-- <div v-if="form.kop_surat_url_image !== '' && form.kop_surat_url_image !== null"
        style="margin-bottom: 16px !important;">
        <v-img
          contain
          width="100%"
          height="auto"
          alt="umb"
          :src="form.kop_surat_url_image">
          <template v-slot:placeholder>
            <v-row
              class="fill-height"
              align="center"
              justify="center">
              <v-progress-circular
                indeterminate
                :color="set_color">
              </v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </div>

      <div
        :style="form.kop_surat_url_image !== '' && form.kop_surat_url_image !== null ? `padding: 0px 38px 0px 38px;` : 'padding: 38px;'"> -->
        <v-card-text
          class="black--text py-2">
          <div class="font-weight-bold mb-3" style="font-weight: bold; margin-bottom: 12px;">
            Surat Tugas
          </div>
          <v-row>
            <v-col
              cols="12"
              md="7">
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                  class="py-0"
                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                  Nomor
                </v-col>

                <v-col
                  cols="12"
                  md="8"
                  class="py-0"
                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                  : {{ selected.preview.template_meta_json_object.nomor !== '' ? selected.preview.template_meta_json_object.nomor : '__________' }}
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  cols="12"
                  md="4"
                  class="py-0"
                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                  Hal
                </v-col>

                <v-col
                  cols="12"
                  md="8"
                  class="py-0"
                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                  : <span style="font-weight: 500;">{{ selected.preview.template_meta_json_object.hal !== '' ? selected.preview.template_meta_json_object.hal : '__________' }}</span>
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  cols="12"
                  md="4"
                  class="py-0"
                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                  Lampiran
                </v-col>

                <v-col
                  cols="12"
                  md="8"
                  class="py-0"
                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                  : {{ selected.preview.template_meta_json_object.lampiran !== '' ? selected.preview.template_meta_json_object.lampiran : '__________' }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <div class="mt-4 px-3" style="padding-left: 12px;">
            <v-img
              contain
              width="175"
              height="auto"
              alt="umb"
              :src="require('@/assets/image/assalam.jpeg')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular
                    indeterminate
                    :color="set_color">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>


          <div
            class="mt-0"
            style="margin-top: 8px !important;">
            <div
              style="margin-bottom: 1px;">
              Yang bertanda tangan di bawah ini:
            </div>

            <div class="my-3">
              <v-row>
                <v-col
                  cols="12"
                  md="2"
                  class="py-0"
                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                  Nama
                </v-col>

                <v-col
                  cols="12"
                  md="10"
                  class="py-0"
                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                  : {{ selected.preview.template_meta_json_object.nama_1 !== '' ? selected.preview.template_meta_json_object.nama_1 : '__________' }}
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  cols="12"
                  md="2"
                  class="py-0"
                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                  Jabatan
                </v-col>

                <v-col
                  cols="12"
                  md="10"
                  class="py-0"
                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                  : {{ selected.preview.template_meta_json_object.jabatan_1 !== '' ? selected.preview.template_meta_json_object.jabatan_1 : '__________' }}
                </v-col>
              </v-row>
            </div>


            <div
              style="margin-bottom: 1px;" class="mb-3">
              Dengan ini memberikan tugas kepada:
            </div>

            <div
              v-for="(item, index) in selected.preview.template_meta_json_object.kepada"
              :key="index"
              style="margin-bottom: 16px;">
              <div>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                    class="py-0"
                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                    Nama
                  </v-col>

                  <v-col
                    cols="12"
                    md="10"
                    class="py-0"
                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                    : {{ item.nama !== '' ? item.nama : '__________' }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                    class="py-0"
                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                    Jabatan
                  </v-col>

                  <v-col
                    cols="12"
                    md="10"
                    class="py-0"
                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                    : {{ item.unit !== '' ? item.unit : '__________' }}
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>

          <div
            class="mt-8"
            style="margin-top: 20px !important;">

            <div
              style="margin-bottom: 1px;">
              Untuk melaksanakan tugas sebagai berikut:
            </div>

            <div
              class="my-4"
              style="margin-top: 16px !important; margin-bottom: 16px !important;">
              <div
                class="mb-4 font-weight-bold"
                style="margin-bottom: 16px !important; font-weight: bold;">
                Deskripsi Tugas:
              </div>

              <div
                class="mb-4"
                style="margin-left: 22px; margin-bottom: 16px !important;">
                <ol>
                  <li
                    class="pl-2"
                    style="padding-left: 8px !important;"
                    v-for="(item, index) in selected.preview.template_meta_json_object.deskripsi" :key="index">
                    {{ item.text !== '' ? item.text : '__________' }}
                  </li>
                </ol>
              </div>

              <div
                class="mb-4 font-weight-bold"
                style="margin-bottom: 16px !important; font-weight: bold;">
                Waktu Pelaksanaan:
              </div>

              <div
                class="mb-4"
                style="margin-bottom: 16px !important;">
                Mulai dari tanggal
                <span v-if="selected.preview.template_meta_json_object.tanggal_mulai !== '' && selected.preview.template_meta_json_object.tanggal_mulai !== null">
                  {{ selected.preview.template_meta_json_object.tanggal_mulai | fulldate }}
                </span>

                <span v-else>
                  __________
                </span>
                sampai dengan tanggal
                <span v-if="selected.preview.template_meta_json_object.tanggal_selesai !== '' && selected.preview.template_meta_json_object.tanggal_selesai !== null">
                  {{ selected.preview.template_meta_json_object.tanggal_selesai | fulldate }}
                </span>

                <span v-else>
                  __________
                </span>
              </div>

              <div
                class="mb-4 font-weight-bold"
                style="margin-bottom: 16px !important; font-weight: bold;">
                Tempat Pelaksanaan:
              </div>
              <div
                class="mb-4">
                {{ selected.preview.template_meta_json_object.tempat !== '' ? selected.preview.template_meta_json_object.tempat : '__________' }}
              </div>

              <div
                style="">
                Demikian surat tugas ini dibuat untuk dapat dilaksanakan dengan penuh tanggung jawab, atas perhatiannya kami ucapkan terima kasih.
              </div>
            </div>

            <div class="px-3" style="padding-left: 12px;">
              <v-img
                contain
                width="175"
                height="auto"
                alt="umb"
                :src="require('@/assets/image/wassalam.jpeg')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular
                      indeterminate
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>
          </div>

          <v-row
            justify="end"
            class="mt-8"
            style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
            <v-col
              cols="12"
              md="6"
              class="text-center"
              style="text-align: right !important;">
              <div>
                Yogyakarta, {{ selected.preview.template_meta_json_object.tanggal | fulldate }}
              </div>

              <div
                class="mb-16"
                style="margin-bottom: 64px !important;">
                {{ selected.preview.template_meta_json_object.jabatan_1 !== '' ? selected.preview.template_meta_json_object.jabatan_1 : '__________' }}
              </div>

              <div>
                {{ selected.preview.template_meta_json_object.nama_1 !== '' ? selected.preview.template_meta_json_object.nama_1 : '__________' }}
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      <!-- </div>

      <div v-if="form.kop_surat_url_image_footer !== '' && form.kop_surat_url_image_footer !== null"
        style="margin-top: 16px !important;">
        <v-img
          style="position: absolute; bottom: 0;"
          contain
          width="100%"
          height="auto"
          alt="umb"
          :src="form.kop_surat_url_image_footer">
          <template v-slot:placeholder>
            <v-row
              class="fill-height"
              align="center"
              justify="center">
              <v-progress-circular
                indeterminate
                :color="set_color">
              </v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </div> -->
    </div>
  </template>

  <script>
    import moment from "moment"
  import "moment/locale/id"
  import html2pdf from 'html2pdf.js'
    export default {
      props: {
        form: {
          type: Object,
          default: {}
        },
        selected: {
          type: Object,
          default: {}
        },
        // units: {
        //   type: Array,
        //   default: []
        // },
        process: {
          type: Object,
          default: {}
        }
      },
      data () {
        return {
          picker: {
            expired: false,
            tanggal: false,
            tanggal_mulai: false,
            tanggal_selesai: false,
            tanggal_masuk: false,

            range: false
          },

          time: {
            pukul: false
          },
        }
      },
      components: {

      },
      watch: {

      },
      computed: {
        user () {
          return this.$store.state.user
        },

        set_color () {
          return this.$store.state.color
        },
        set_color_rgb_soft () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

          return `rgba(${r}, ${g}, ${b}, 0.2)`
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

          return `rgba(${r}, ${g}, ${b}, 0.2)`
        },

        configHeaders () {
          return this.headers.filter(header => !header.hide)
        },

        // formattedDate: {
        //   get () {
        //     return (this.selected.preview.template_meta_json_object.tanggal && this.selected.preview.template_meta_json_object.tanggal.length === 10) ? moment(this.selected.preview.template_meta_json_object.tanggal).format('DD MMMM YYYY') : this.selected.preview.template_meta_json_object.tanggal
        //   },
        //   set (newValue) {
        //     if (newValue && newValue.length == 10) {
        //         let newDate = `${newValue.substring(6, 10)}-${newValue.substring(3, 5)}-${newValue.substring(0, 2)}`
        //         this.selected.preview.template_meta_json_object.tanggal = newDate
        //     }
        //   }
        // },

        date_range () {
          return this.filter.dates.join(' s/d ')
        }
      },
      mounted () {

      },
      methods: {

      }
    }
  </script>
